import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuildingColumns, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import BankAccounts from '../Companies/BankAccounts/BankAccounts';
import Loader from '../Layout/Loader';
import useSettingsCompany from './useSettingsCompany';
import SettingsBreadcrumb from './SettingsBreadcrumb';
import './settings.scss';

const BankAccountsSettings = () => {
  const { t } = useTranslation('translations');
  const {
    company,
    setCompany,
    getCompany,
    loading,
    isAdminMode,
    getBackUrl,
  } = useSettingsCompany();

  if (loading || !company) {
    return <Loader />;
  }

  return (
    <div className="settings-subpage">
      <SettingsBreadcrumb
        items={[{ label: t('company.bankAccounts') }]}
        company={company}
        isAdminMode={isAdminMode}
      />

      <div className="settings-subpage__header">
        <Link to={getBackUrl()} className="settings-subpage__back-btn">
          <FontAwesomeIcon icon={faArrowLeft} />
        </Link>
        <h2 className="settings-subpage__title">
          <span className="settings-subpage__icon">
            <FontAwesomeIcon icon={faBuildingColumns} />
          </span>
          {t('company.bankAccounts')}
        </h2>
        {company && (
          <span className="settings-subpage__company-badge">
            {company.name}
          </span>
        )}
      </div>

      <BankAccounts
        company={company}
        getCompany={getCompany}
        setCompany={setCompany}
      />
    </div>
  );
};

export default BankAccountsSettings;
